import { detectMiniAppPlatform, ensureLocalMaxBridgeLoaded, MiniAppPlatform } from "../utils/miniapp-platform";

export enum Platform {
    Telegram = "telegram",
    Max = "max",
    Desktop = "desktop",
}

let cachedPlatform: Platform | undefined;

const normalizePlatform = (p: MiniAppPlatform): Platform => {
    switch (p) {
        case MiniAppPlatform.Telegram:
            return Platform.Telegram;
        case MiniAppPlatform.Max:
            return Platform.Max;
        default:
            return Platform.Desktop;
    }
};

export const detectPlatform = (): Platform => normalizePlatform(detectMiniAppPlatform());

export const initPlatform = async (): Promise<Platform> => {
    await ensureLocalMaxBridgeLoaded();
    cachedPlatform = detectPlatform();
    return cachedPlatform;
};

export const getPlatform = (): Platform => {
    if (cachedPlatform) return cachedPlatform;
    cachedPlatform = detectPlatform();
    return cachedPlatform;
};

export const resetPlatformCache = (): void => {
    cachedPlatform = undefined;
};

export const isTelegramPlatform = (): boolean => getPlatform() === Platform.Telegram;
export const isMaxPlatform = (): boolean => getPlatform() === Platform.Max;
export const isDesktopPlatform = (): boolean => getPlatform() === Platform.Desktop;

export const getPlatformTitle = (platform: Platform): string => {
    switch (platform) {
        case Platform.Telegram:
            return "Телеграм";
        case Platform.Max:
            return "Макс";
        default:
            return "Браузер";
    }
};

